module.exports = __webpack_public_path__ + "img/expert-icon.f76c3e7b.png";